import { Banner, Title, Status, StartVerify, Features, Requirements, GetStarted } from "./components";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


function App() {
  return (
    <div className="business-verification-wrap">
        <Banner title="Get Your Business Verified!" />
        <Title title="Business Verification" />
        <Status />
        <StartVerify />
        <Features />
        <Requirements />
        <GetStarted />
    </div>
  );
}

export default App;
